import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PlaylistService, MessagesServices } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { ConfirmDialogComponent } from '../../';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';

@Component({
  selector: 'delete-playlist',
  templateUrl: './delete-playlist.component.html',
  styleUrls: ['./delete-playlist.component.css']
})
export class DeletePlaylistComponent implements OnInit {
  @Input() playlist: any;
  dialogRef: MdDialogRef<ConfirmDialogComponent>;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';
  public onlineOffline1: boolean = navigator.onLine;
  isOnPlaylistPage: boolean = false;

  constructor(private playlistService: PlaylistService, private sm: MessagesServices, private toastyService: ToastyService, public dialog: MdDialog, private route: ActivatedRoute, private router: Router) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});
    /**
    * getting system messages from db
    **/
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if(isEmpty(params)) {
        this.isOnPlaylistPage = false;
      } else {
        this.isOnPlaylistPage = true;
      }
    });
  }

  /**
   * setting system messages
   **/
  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    this.msg2 = '';
    this.title2 = '';
    this.msg3 = '';
    this.title3 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_PLAYLIST_DELETED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_PLAYLIST_CANNOT_BE_DELETED') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ARE_YOU_SURE_TO_DELETE_THIS_PLAYLIST') {
          this.msg3 = this.messages[i].message;
        }
      }
    }
  }

  deletePlaylist(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false,
    });
    this.dialogRef.componentInstance.message = this.msg3;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result && result === true) {
        if(this.onlineOffline1){
          this.playlistService.deletePlaylist(this.playlist.id).subscribe((res) => {
            let toastOptions: ToastOptions = {
              title: this.title1,
              msg: this.msg1,
              showClose: true,
              timeout: 2000,
              theme: 'default'
            };
          this.playlistService.isPlaylistUpdated.next(true);
          this.toastyService.success(toastOptions);
          if(this.isOnPlaylistPage == true) {
            this.router.navigate(['/playlists']);
          }
        }, (err) => {
          let toastOptions: ToastOptions = {
            title: this.title2,
            msg: this.msg2,
            showClose: true,
            timeout: 2000,
            theme: 'default'
          };
          this.toastyService.error(toastOptions);
        });
        }
      }
    });    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/delete-playlist/delete-playlist.component.ts